import React, { useState } from "react";
import { Card } from "./ui/card";
import { Badge } from "./ui/badge";
import { Button } from "./ui/button";
import Header from "./Header";
import Footer from "./Footer";
import {
  Building2,
  Stethoscope,
  Users,
  Award,
  X,
  ChevronLeft,
  ChevronRight,
  Calendar,
  Phone,
} from "lucide-react";
import { useNavigate } from "react-router-dom";

const GalleryPage = () => {
  const navigate = useNavigate();
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  const galleryImages = [
    {
      url: "/reception1.png",
      title: "Clinic Interior",
      category: "Facilities",
      description:
        "Our luxurious and modern clinic environment designed for patient comfort and professional care.",
    },
    {
      url: "/ModernFac.webp",
      title: "Modern Facility",
      category: "Facilities",
      description: "State-of-the-art treatment rooms",
      
    },
    {
      url: "/ComfortCare.webp",
      title: "Comfort & Care",
      category: "Facilities",
      description: "Relaxing environment for healing",
    },
    {
      url: "/reception2.jpg",
      title: "Elegant Reception Area",
      category: "Facilities",
      description: "A warm, modern space designed for your comfort.",
    },
    // {
    //   url: "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHxwaHlzaW90aGVyYXB5fGVufDB8fHx8MTc1MzAzNzEzMHww&ixlib=rb-4.1.0&q=85",
    //   title: "Professional Massage Therapy",
    //   category: "Treatment",
    //   description:
    //     "Expert massage therapy sessions providing therapeutic relief and wellness care.",
    // },
    {
      url: "/ChiropracticCare.webp",
      title: "Chiropractic Excellence",
      category: "Treatment",
      description:
        "Specialized chiropractic treatments for spinal health and alignment correction.",
    },
    {
      url: "/BWSTT.png",
      title: "Body-Weight Supported Treadmill Training (BWSTT)",
      category: "Treatment",
      description:
        "Therapy using body-weight support to improve walking and balance on a treadmill.",
    },
    {
      url: "/chiro.png",
      title: "Cervical Traction Therapy",
      category: "Treatment",
      description:
        "Therapy that gently stretches the neck to relieve pain and improve mobility.",
    },
    {
      url: "/rehabtn.webp",
      title: "Passive Range of Motion (PROM) Therapy",
      category: "Treatment",
      description:
        "Therapy where the therapist moves the patient's limbs to maintain joint flexibility and prevent stiffness.",
    },
    {
      url: "/painMnmt.jpg",
      title: "Radio Frequency Therapy (RFT)",
      category: "Treatment",
      description:
        "Therapy using radio waves to relieve pain, relax muscles, and promote deep tissue healing.",
    },
    {
      url: "/rbltn.jpg",
      title: "Gait Training with Parallel Bars",
      category: "Treatment",
      description:
        "Rehabilitation exercise that helps patients improve balance, strength, and walking ability using parallel bars.",
    },
    {
      url: "/SwissBallTherapy.webp",
      title: "Swiss Ball Therapy",
      category: "Treatment",
      description:
        "Therapy using an exercise ball to improve a child’s balance, posture, and motor coordination through guided movements.",
    },
    {
      url: "/ParallelBars.png",
      title: "Parallel Bars",
      category: "Treatment",
      description:
        "Bars used in physiotherapy to improve balance, coordination, and walking stability during rehabilitation.",
    },
    {
      url: "/Electrotherapy.webp",
      title: "Electrotherapy Treatment",
      category: "Treatment",
      description:
        "Electrotherapy sessions using mild currents to relieve pain, stimulate muscles, and support rehabilitation.",
    },
    // {
    //   url: "https://images.unsplash.com/photo-1645005512968-0c1fe99f0093?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwzfHxwaHlzaW90aGVyYXB5fGVufDB8fHx8MTc1MzAzNzEzMHww&ixlib=rb-4.1.0&q=85",
    //   title: "Rehabilitation Therapy",
    //   category: "Treatment",
    //   description:
    //     "Comprehensive rehabilitation programs designed for optimal recovery and function.",
    // },
    // {
    //   url: "./Physiotherapy.jpg",
    //   title: "Physiotherapy Electrotherapy",
    //   category: "Treatment",
    //   description:
    //     "Physiotherapy using TENS to relieve pain, reduce spasms, and aid muscle rehabilitation.",
    // },
    {
      url: "/ultrasound.webp",
      title: "State-of-the-Art Equipment",
      category: "Equipment",
      description:
        "Advanced monitoring and diagnostic technology for precise patient care.",
    },
    {
      url: "/btl.webp",
      title: "Professional Diagnostics",
      category: "Equipment",
      description:
        "Cutting-edge diagnostic equipment for accurate assessment and treatment planning.",
    },
    // {
    //   url: "https://images.unsplash.com/photo-1606206873764-fd15e242df52?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwzfHxtZWRpY2FsJTIwZXF1aXBtZW50fGVufDB8fHx8MTc1MzAzNzEzOHww&ixlib=rb-4.1.0&q=85",
    //   title: "Advanced Medical Technology",
    //   category: "Equipment",
    //   description:
    //     "Modern medical technology ensuring the highest standards of patient care.",
    // },
    {
      url: "/MEChair.jpg",
      title: "Rehab Industries MEC Multi-Exercise Chair",
      category: "Equipment",
      description:
        "Physiotherapy chair for multi-exercise rehab with adjustable, full-body support.",
    },
    {
      url: "/Treadmill.jpg",
      title: "Rehab Treadmill with Support System",
      category: "Equipment",
      description:
        "Treadmill with body-weight support for safe physiotherapy and gait training.",
    },
    {
      url: "/StationaryBicycle.jpg",
      title: "Stationary bicycle",
      category: "Equipment",
      description:
        "A fitness bike for physiotherapy and cardio training that strengthens legs and improves joint mobility.",
    },
    // {
    //   url: "./team.jpg",
    //   title: "Expert Medical Professional",
    //   category: "Team",
    //   description:
    //     "Our qualified healthcare professionals dedicated to providing exceptional patient care.",
    // },
    {
      url: "/Team2.webp",
      title: "Expert Medical Team",
      category: "Team",
      description:
        "Team of expert doctors showcasing their credentials and dedication to quality healthcare.",
    },
    {
      url: "/allStaff.jpg",
      title: "Certified Physiotherapist",
      category: "Team",
      description:
        "Board-certified physiotherapists with advanced credentials and years of experience.",
    },
    // {
    //   url: "https://images.unsplash.com/photo-1575433287483-8ec588f72417?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwyfHxzYXRpc2ZpZWQlMjBjbGllbnRzfGVufDB8fHx8MTc1MzAzNzIyNnww&ixlib=rb-4.1.0&q=85",
    //   title: "Satisfied Patient",
    //   category: "Success Stories",
    //   description:
    //     "Happy patients who have experienced life-changing results through our care.",
    // },
    // {
    //   url: "https://images.unsplash.com/photo-1687436874044-2c593fbf0245?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHx3ZWxsbmVzcyUyMHJlY292ZXJ5fGVufDB8fHx8MTc1MzAzNzIxOHww&ixlib=rb-4.1.0&q=85",
    //   title: "Wellness & Recovery",
    //   category: "Success Stories",
    //   description:
    //     "Community wellness programs that promote health, recovery, and overall well-being.",
    // },
    // {
    //   url: "https://images.unsplash.com/photo-1687181133399-668ddc50065c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwyfHx3ZWxsbmVzcyUyMHJlY292ZXJ5fGVufDB8fHx8MTc1MzAzNzIxOHww&ixlib=rb-4.1.0&q=85",
    //   title: "Group Wellness Programs",
    //   category: "Success Stories",
    //   description:
    //     "Empowering group sessions that build community and promote healthy living.",
    // },
    {
      url: "/Harish Jasti.webp",
      title: "Dr. Harish Jasti",
      category: "Our Founder",
      description:
        "Founder & visionary behind our state-of-the-art clinic, dedicated to patient care.",
    },
    {
      url: "/withNitishKumar.jpg",
      title: "Visionary Leadership",
      category: "Our Founder",
      description:
        "Dr. Harish Jasti, our founder, with Nitish Kumar, reflecting visionary leadership and a commitment to excellence in healthcare.",
    },
    {
      url: "/withSarvanandh.jpg",
      title: "Dr. Harish Jasti",
      category: "Our Founder",
      description:
        "Dr. Harish Jasti, our visionary founder, alongside Hero Sarvanandh, sharing a moment that celebrates excellence and inspiration in healthcare.",
    },
    {
      url: "/bezawadaTigers.jpg",
      title: "Founder at Work",
      category: "Our Founder",
      description:
        "Dr. Harish Jasti interacting with the Bezawada Tigers, showcasing hands-on leadership and a commitment to teamwork and excellence.",
    },
    {
      url: "/aplTeam.jpg",
      title: "Guiding Excellence",
      category: "Our Founder",
      description:
        "Dr. Harish Jasti with the APL Team, showcasing hands-on leadership and inspiring excellence through teamwork and innovation in healthcare.",
    },
    {
      url: "/cricketers.jpg",
      title: "With the Game Changers",
      category: "Our Founder",
      description:
        "Sharing a cheerful moment with leading cricketers, Dr. Harish Jasti continues to bridge the gap between sports and health through passion and dedication.",
    },
    {
      url: "/events.jpeg",
      title: "On-Field Care",
      category: "Our Founder",
      description:
        "Dr. Harish Jasti providing on-field medical assistance during the APL match, showcasing dedication and expertise in sports medicine.",
    },
    {
      url: "/excellence.jpg",
      title: "Award for Excellence",
      category: "Awards",
      description:
        "Dr. Harish Jasti receiving the ‘Best Clinician Award’ for his outstanding contributions to physiotherapy and patient care, exemplifying dedication and leadership in the medical field.",
    },
    {
      url: "/Awards.webp",
      title: "Global Achievement",
      category: "Awards",
      description:
        "Dr. Harish Jasti at The Ackermann College, Stockholm, receiving international recognition for his expertise in chiropractic care and dedication to advancing global healthcare standards.",
    },
    {
      url: "/cer1.jpg",
      title: "Certifications & Achievements",
      category: "Awards",
      description:
        "A showcase of professional certifications recognizing advanced skills in physiotherapy and chiropractic care.",
    },
    {
      url: "/cer2.jpg",
      title: "Professional Certifications",
      category: "Awards",
      description:
        "Recognitions and diplomas highlighting advanced qualifications in chiropractic and physiotherapy care.",
    },
  ];

  const categories = [
    { name: "All", icon: Building2 },
    { name: "Facilities", icon: Building2 },
    { name: "Treatment", icon: Stethoscope },
    { name: "Equipment", icon: Award },
    { name: "Our Founder", icon: Users },
    { name: "Team", icon: Users },
    { name: "Awards", icon: Award },
    // { name: "Success Stories", icon: Award },
  ];

  const [activeCategory, setActiveCategory] = useState("All");

  const filteredImages =
    activeCategory === "All"
      ? galleryImages
      : galleryImages.filter((img) => img.category === activeCategory);

  const openModal = (image, index) => {
    setSelectedImage(image);
    setCurrentIndex(index);
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  const navigateImage = (direction) => {
    const newIndex =
      direction === "next"
        ? (currentIndex + 1) % filteredImages.length
        : (currentIndex - 1 + filteredImages.length) % filteredImages.length;

    setCurrentIndex(newIndex);
    setSelectedImage(filteredImages[newIndex]);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-blue-50">
      <Header />

      {/* Hero Section */}
      <section className="pt-20 pb-16 bg-gradient-to-r from-[#204080] to-[#2E5AAC] text-white relative overflow-hidden">
        <div className="absolute inset-0 bg-black/20"></div>
        <div className="absolute top-0 right-0 w-96 h-96 bg-white/10 rounded-full blur-3xl translate-x-1/3 -translate-y-1/3"></div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="text-center">
            <h1 className="text-4xl lg:text-6xl font-bold mb-6 font-serif">
              Our Gallery
            </h1>
            <p className="text-xl lg:text-2xl text-blue-100 mb-8 max-w-3xl mx-auto">
              Explore our world-class facilities, advanced equipment, expert
              team, and the success stories of our patients
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              {/* <Button className="bg-white text-[#204080] hover:bg-blue-50 px-8 py-3 text-lg font-semibold rounded-lg shadow-lg">
                <Calendar className="mr-2" size={20} />
                Schedule Tour
              </Button> */}
              <Button
                variant="outline"
                onClick={() =>
                  navigate("/", { state: { scrollTo: "contact" } })
                }
                className="border-2 border-white text-white hover:bg-white hover:text-[#204080] px-8 py-3 text-lg font-semibold rounded-lg"
              >
                <Phone className="mr-2" size={20} />
                Contact Us
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Category Filters */}
          <div className="flex flex-wrap justify-center gap-4 mb-12">
            {categories.map((category) => {
              const IconComponent = category.icon;
              return (
                <button
                  key={category.name}
                  onClick={() => setActiveCategory(category.name)}
                  className={`flex items-center space-x-2 px-6 py-3 rounded-lg font-semibold transition-all duration-300 ${
                    activeCategory === category.name
                      ? "bg-gradient-to-r from-[#204080] to-[#2E5AAC] text-white shadow-lg"
                      : "bg-white text-gray-700 hover:bg-gray-100 border border-gray-200"
                  }`}
                >
                  <IconComponent size={18} />
                  <span>{category.name}</span>
                </button>
              );
            })}
          </div>

          {/* Image Grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {filteredImages.map((image, index) => (
              <Card
                key={`${image.category}-${index}`}
                className="group overflow-hidden cursor-pointer hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 border-0"
                onClick={() => openModal(image, index)}
              >
                <div className="relative">
                  <img
                    src={image.url}
                    alt={image.title}
                    loading="lazy"
                    className="w-full h-64 object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

                  {/* Category Badge */}
                  <Badge className="absolute top-3 left-3 bg-white/90 text-[#204080] hover:bg-white">
                    {image.category}
                  </Badge>

                  {/* Title Overlay */}
                  <div className="absolute bottom-0 left-0 right-0 p-4 text-white transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300">
                    <h3 className="text-lg font-bold mb-1">{image.title}</h3>
                    <p className="text-sm text-white/90 opacity-0 group-hover:opacity-100 transition-opacity duration-300 delay-100">
                      {image.description}
                    </p>
                  </div>
                </div>
              </Card>
            ))}
          </div>

          {/* Gallery Stats */}
          <div className="mt-20 grid grid-cols-2 lg:grid-cols-4 gap-6">
            <Card className="p-6 text-center bg-gradient-to-br from-[#204080] to-[#2E5AAC] text-white border-0 shadow-xl">
              <div className="text-3xl font-bold mb-2">22+</div>
              <div className="text-blue-100 text-sm">Years of Excellence</div>
            </Card>

            <Card className="p-6 text-center bg-white/90 backdrop-blur-sm border border-gray-200 shadow-lg">
              <div className="text-3xl font-bold text-[#204080] mb-2">
                1,10,000+
              </div>
              <div className="text-gray-600 text-sm">Success Stories</div>
            </Card>

            <Card className="p-6 text-center bg-gradient-to-br from-emerald-500 to-teal-600 text-white border-0 shadow-xl">
              <div className="text-3xl font-bold mb-2">80+</div>
              <div className="text-emerald-100 text-sm">Awards Won</div>
            </Card>

            <Card className="p-6 text-center bg-white/90 backdrop-blur-sm border border-gray-200 shadow-lg">
              <div className="text-3xl font-bold text-[#204080] mb-2">2</div>
              <div className="text-gray-600 text-sm">Locations</div>
            </Card>
          </div>
        </div>
      </section>

      {/* Image Modal */}
      {selectedImage && (
        <div className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4">
          <div className="relative max-w-4xl w-full">
            {/* Close Button */}
            <button
              onClick={closeModal}
              className="absolute top-4 right-4 z-10 p-2 bg-white/20 hover:bg-white/30 rounded-full transition-colors duration-200"
            >
              <X size={24} className="text-white" />
            </button>

            {/* Navigation Buttons */}
            <button
              onClick={() => navigateImage("prev")}
              className="absolute left-4 top-1/2 transform -translate-y-1/2 z-10 p-2 bg-white/20 hover:bg-white/30 rounded-full transition-colors duration-200"
            >
              <ChevronLeft size={32} className="text-white" />
            </button>

            <button
              onClick={() => navigateImage("next")}
              className="absolute right-4 top-1/2 transform -translate-y-1/2 z-10 p-2 bg-white/20 hover:bg-white/30 rounded-full transition-colors duration-200"
            >
              <ChevronRight size={32} className="text-white" />
            </button>

            {/* Image */}
            <img
              src={selectedImage.url}
              alt={selectedImage.title}
              loading="lazy"
              className="w-full h-auto max-h-screen object-contain rounded-lg"
            />

            {/* Image Info */}
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-6 text-white">
              <Badge className="mb-3 bg-white/20 text-white">
                {selectedImage.category}
              </Badge>
              <h3 className="text-2xl font-bold mb-2">{selectedImage.title}</h3>
              <p className="text-white/90">{selectedImage.description}</p>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default GalleryPage;
